/* パスワード変更（共通） */
import React from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Text from '../../molecules/Text';
import Annotation from '../../atoms/Annotation';
import CenterButton from '../../atoms/CenterButton';

const PasswordChange: React.FC = () => {
  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="パスワード変更"
        content={
          <>
            <Annotation text="新しいパスワードを入力して下さい。" />
            <div className="mt-3"></div>
            <div>
              <Text
                id="password"
                label="パスワード"
                value=""
                placeholder=""
                disabled={false}
                handleChange={() => {}}
              />
            </div>
            <div className="mt-3">
              <Text
                id="password-confirm"
                label="パスワード(確認)"
                value=""
                placeholder=""
                disabled={false}
                handleChange={() => {}}
              />
            </div>
            <div className="mt-3" />
            <Annotation text="※パスワードは、英字・数字を含む8文字以上で設定して下さい。" />
          </>
        }
      />
      <div className="mt-5" />
      <CenterButton label="パスワード変更" />
      <div className="mt-4"></div>
    </>
  );
};
if (document.getElementById('password-change')) {
  ReactDOM.render(<PasswordChange />, document.getElementById('password-change'));
}
